export default "__VITE_ASSET__DIY_VPW4__"